module.exports = __webpack_public_path__ + "img/database.5a48c0e5.png";